/**
 * bic-bim-api
 * Import from bic-bim-api Function App
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Eine einzelne Anwendbarkeit/Applicability einer Spezifikation. Das Frontend kann Badges aus facetTypeLabel + values zusammensetzen (z.B. \"Entität: IfcWindow\" oder \"Attribut: Name\"). 
 */
export interface BicReportApplicability { 
    /**
     * Typ des IDS-Facets (interner Schlüssel)
     */
    facetType: BicReportApplicability.FacetTypeEnum;
    /**
     * Lokalisierte Bezeichnung des Facet-Typs. Mögliche Werte: \"Entität\", \"Attribut\", \"Klassifikation\", \"Eigenschaft\", \"Material\", \"Teilbeziehung\" 
     */
    facetTypeLabel: string;
    /**
     * Hauptanzeigewert des Facets (z.B. \"IfcWindow\", \"Name\", \"NL-SfB tabel 1\"). Kann null sein bei Enumerationen mit mehreren Werten. 
     */
    value?: string;
    /**
     * Alle Werte dieses Facets als vollständige Liste. Bei Entity: alle IFC-Typen (z.B. [\"IfcActuator\", \"IfcAirTerminal\", ...]). Bei Attribute mit Enumeration: alle erlaubten Werte. Bei Attribute mit Pattern: die Pattern-Werte. 
     */
    values?: Array<string>;
}
export namespace BicReportApplicability {
    export type FacetTypeEnum = 'Entity' | 'Attribute' | 'Classification' | 'Property' | 'Material' | 'PartOf';
    export const FacetTypeEnum = {
        Entity: 'Entity' as FacetTypeEnum,
        Attribute: 'Attribute' as FacetTypeEnum,
        Classification: 'Classification' as FacetTypeEnum,
        Property: 'Property' as FacetTypeEnum,
        Material: 'Material' as FacetTypeEnum,
        PartOf: 'PartOf' as FacetTypeEnum
    };
}